<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      沙井站<br>
站点介绍<br>
沙井站位于宝安大道沙井街道鸿荣源禧园路段，宝安大道与新沙路交叉口北侧，沿宝安大道呈南北向布置.该站为高架站<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:13	23:44	11号线	4分钟	6分32秒<br>
碧头	06:38	00:22	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:13	23:44	11号线	4分34秒	6分钟<br>
碧头	06:38	00:22	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:13	23:44	11号线	4分37秒	6分钟<br>
碧头	06:38	00:22	11号线	4分37秒	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
壆岗派出所、华美居、壆岗市场、中亚硅谷、荣根学校、盛芳园、沙井中学、沙井镇政府、沙井公园、沙井壆岗社区、蚝乡路、锦岗街（路）、海上田园旅游区、壆岗荔枝公园、沙井卫生监督所、北环路、益华电子城<br><br>
B出入口:<br>
沃尔玛、西荟城、京基百纳、新沙天虹、沙井老街、沙井街道办、沙井汽车站、壆岗医院、壆岗大道 、万科翡丽郡、明珠市场、沙井一村、新沙义乌、西环路、深圳市第七高级中学、民主大道、穗深城际铁路沙井西站、壆岗大厦、沙井人民医院<br><br>
C出入口:<br>
新沙路、华润万家、万丰小学、百佳华奥莱店、沙井中心客运站、万丰影剧院、沙井电子城、上寮市场、中心路、社保局、市民广场、西部茶城、荣泰园、万丰医院、禧格酒店、浦发银行、工商银行、华夏银行、佳音幼儿园、沙井天虹、招商银行、沙井老义乌<br><br>
D出入口:<br>
鸿荣源·禧园、维也纳酒店（深圳国际会展中心沙井地铁站店）、民主大道、国税局（沙井税务所）、百佳华领创广场、金汇雅园、宝安书城、卓越时代大厦、新桥粮仓、新桥市场、江苏银行、新桥派出所、麒麟名都<br><br>
公交换乘信息<br><br>
A口:<br>
公交站名： 坪山区委区政府<br>
366、M478、978、M325、M136、M297、M422、M361、E34、M434、高峰专线64路、深惠3A线、深惠2线<br><br>
C口:<br>
公交站名： 大工业区体育中心<br>
366、M478、978、M325、M136、M297、M422、M361、M434、高峰专线64路<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>